<template>
  <div class="myComment">
    <div class="personal-box comWidth">
      <CenterNav/>
      <div class="personal-right">
        <NavT :titleS="titleS"/>
        <div class="rightmain">
          <el-table
            border
            :data="commentsList"
            style="width: 100%">
            <el-table-column
              label="商品信息"
              width="260">
              <template slot-scope="scope">
                <img :src="scope.row.goods.goods_thumb"><span>{{scope.row.goods.goods_name}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="評論時間"
              width="180">
              <template  slot-scope="scope">{{scope.row.created_at}}</template>
            </el-table-column>
            <el-table-column
              label="評論內容"
              width="180">
              <template  slot-scope="scope">{{scope.row.comment_reply_desc}}</template>
            </el-table-column>
            <el-table-column
              prop="amount"
              label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="deleteRow(scope.row)"
                  type="danger"
                  size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  //api
  import {myListComments , deleteComments} from '@/api/comment';
  export default {
    name: 'MyComment',
    components:{
      NavT,
      CenterNav
    },
    data () {
      return {
        titleS:'我的評論',
        //评论列表
        commentsList:[]

      }
    },
    methods:{
      /*获取评论列表*/
      getListComments(){
        myListComments().then(res=>{
            this.commentsList = res.data.data;
        })
      },

      /*删除评论*/
      deleteRow(row){
        this.$confirm('此操作将永久删除该评论, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll:false,
          type: 'warning'
        }).then(() => {
          deleteComments(row.id).then(res =>{
            this.$message.success('删除成功');
            //获取评论列表
            this.getListComments();
          })
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      }
    },
    created(){
        //获取评论列表
        this.getListComments();
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/personalPage/orderCenter/MyComment.vue